<template>
  <div class="card">
    <div class="card-header">
      <i class="fa fa-lock"></i>
      {{ componentTitle }}
    </div>
    <div class="card-body">
      <form @submit.prevent="changeUserPassword()">
        <div class="row">
          <div class="form-group col-md-4">
            <label for="password">Hasło</label>
            <input class="form-control"
                   id="password"
                   v-bind:class="{ 'is-invalid': $v.password.$error }"
                   v-custom-validator="$v.password"
                   v-model="$v.password.$model"
                   type="password"/>
            <div class="invalid-feedback" v-if="!$v.password.required">
              {{ $t('error.fieldRequired') }}
            </div>
            <div class="invalid-feedback" v-else-if="!$v.password.minLength">
              {{ $t('error.minLength', [$v.password.$params.minLength.min]) }}
            </div>
          </div>
          <div class="form-group col-md-4">
            <label for="password2">Powtórz hasło</label>
            <input class="form-control"
                   v-bind:class="{ 'is-invalid': $v.password2.$error }"
                   v-model="$v.password2.$model"
                   v-custom-validator="$v.password2"
                   id="password2"
                   type="password"/>
            <div class="invalid-feedback" v-if="!$v.password2.required">
              {{ $t('error.fieldRequired') }}
            </div>
            <div class="invalid-feedback" v-else-if="!$v.password2.sameAsPassword">
              {{ $t('error.sameAsPassword2') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-4">
            <button type="submit" class="btn btn-primary">Zmień hasło</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import usersService from '@Service/users';
  import { required, minLength, sameAs } from 'vuelidate/lib/validators';
  import { toastError, toastSuccess } from '../helpers';

  export default {
    props: ['userId', 'componentTitle'],
    data() {
      return {
        password: '',
        password2: '',
      };
    },
    validations: {
      password2: {
        required,
        sameAsPassword: sameAs('password'),
      },
      password: {
        required,
        minLength: minLength(6),
      },
    },
    methods: {
      changeUserPassword() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          usersService
            .changePassword({
              userId: this.userId,
              password: this.password,
            })
            .then(() => {
              this.password = '';
              this.password2 = '';
              this.$v.$reset();
              toastSuccess(this.$t('messages.password-change.success'));
            })
            .catch(() => toastError(this.$t('messages.password-change.error')));
        }
      },
    },
  };
</script>
